import React,{useState,useEffect} from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import './GamePage.css';
import Answer from '../Answer/Answer';
import AskWord from '../AskWord/AskWord'


const GamePage = (props) => {
    const [isNew,setIsNew] = useState(true);
    const [isAsk,setIsAsk] = useState(false);
    const [isHelp, setIsHelp] = useState(false);
    
    function newLevel() {
       setIsNew(false);
       setIsAsk(true);
    }

	setTimeout(newLevel,4000);

	function helpMe() {
        setIsHelp(true);
        setTimeout(setIsHelp, 4000,false);
		
    };
    useEffect(() => {
        if (props.levelReady) {
		  setTimeout(props.onClick, 4000,'next');
		}
		},[props.levelReady]);

    const askWord = props.gameWords.map((items) =>
        <AskWord key = {items.answerKey} targetKey = {items.answerKey} fake = {items.fake} className = 'askWord beginWord' left = {items.x} top = {items.y} width = {items.widthWord } value = {items.words} hided =  'false' />
    );
     
    const answerPlace = props.answers.map((items) =>
        <Answer key = {items.answerKey} targetKey = {items.answerKey} value = {items.words} widthWord = {items.widthWord} onDrop = {(pri)=>props.onClick(pri)} />
    );

    return(
        <div>
            <img src={props.srcBg} className='smallBg' alt = '' />
				<Text className = 'GameQuestion'  value = {props.topMenu} />  
            <img src={props.src} className='gameImg imgAnimation ' draggable='false' alt={props.imgName} />
            {isNew  ? <Text className='GameText' value={props.curSentens} /> : null}
            {isHelp ? <Text className='GameHelp' value={props.curSentens} /> : null}

            {(isAsk && !isNew) ? (<div> {askWord}</div>) : null}
            {(!isNew) ? (<div hidden={isHelp ? true : false}><div className='answerBox'  >  {answerPlace} </div> </div>) : null}
          
				<Button className = 'PrevSentence'  onClick = {() => props.onClick('prev')} hidden = {(props.step === 0) ? true : false} /> 
				<Button className = 'GameHelpStar' onClick = {() => helpMe()} />
            </div>  
    );
};
export default GamePage;